import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/lib/AuthContext';

/**
 * Where does "Home" take this user?
 *   - Signed out             → Dubs Home (/)
 *   - Signed-in artist team  → their own artist hub (`/artists/{slug}`)
 *   - Signed-in fan          → Dubs Home (/)
 *
 * The artist-team check is a single artist_members lookup so team members
 * go straight to their studio; everyone else lands on Dubs Home, the single
 * front-door page (signed out or in).
 */
export function useHomeHref(): string {
  const { session } = useAuth();
  const [ownArtistSlug, setOwnArtistSlug] = useState<string | null>(null);

  useEffect(() => {
    if (!session?.user.id) {
      setOwnArtistSlug(null);
      return;
    }
    let alive = true;
    void supabase
      .from('artist_members')
      .select('artist:artists!inner(slug)')
      .eq('user_id', session.user.id)
      .limit(1)
      .maybeSingle()
      .returns<{ artist: { slug: string } | null } | null>()
      .then(({ data }) => {
        if (!alive) return;
        setOwnArtistSlug(data?.artist?.slug ?? null);
      });
    return () => {
      alive = false;
    };
  }, [session?.user.id]);

  if (!session) return '/';
  if (ownArtistSlug) return `/artists/${ownArtistSlug}`;
  return '/';
}
